module.exports = __webpack_public_path__ + "static/media/SRE007_02.4622bd68.jpg";